/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{position:absolute;width:calc(100% - 2rem);height:100%;top:0;display:flex;justify-content:center;align-items:center;color:#666}"];
export { styles as styles };
